export default __webpack_public_path__ + "static/media/PonyFinals.872456c6.png";